
import { Component, Vue, Prop} from 'vue-property-decorator';

import PageBase from "../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import _ from 'underscore';
const applicationState = namespace("Application");

@Component({
    components:{
        PageBase
    }
})
export default class IncomeSummaryFs extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = false;
    tableKey = 0;
    deductionsTableKey = 0; 
    additionsTableKey = 0; 
    childSupportTableKey = 0;
    extraExpensesTableKey = 0;
    spouseExpensesTableKey = 0;
    extraExpenses = false;
    spouseSupport = false;
    
    totalIncomeItem = [
        {lineNumber: 1, amountName:"totalIncome",   yearlyAmount: 0}
    ];

    deductionItem = [
        {lineNumber: 2,  amountName:"childSupportReceived",    yearlyAmount: 0},
        {lineNumber: 3,  amountName:"spouseSupportReceived",   yearlyAmount: 0},
        {lineNumber: 4,  amountName:"uccb",                    yearlyAmount: 0},
        {lineNumber: 5,  amountName:"splitPension",            yearlyAmount: 0},
        {lineNumber: 6,  amountName:"employmentExpense",       yearlyAmount: 0},
        {lineNumber: 7,  amountName:"socialAssistance",        yearlyAmount: 0},
        {lineNumber: 8,  amountName:"excessPortion",           yearlyAmount: 0},
        {lineNumber: 9,  amountName:"investmentLosses",        yearlyAmount: 0},
        {lineNumber: 10, amountName:"carryingCharges",         yearlyAmount: 0},
        {lineNumber: 11, amountName:"partnership",             yearlyAmount: 0},
        {lineNumber: 12, amountName:"deductionTotal",          yearlyAmount: 0}
    ];

    additionItem = [
        {lineNumber: 13,  amountName:"capitalOffset",    yearlyAmount: 0},
        {lineNumber: 14,  amountName:"selfEmployment",   yearlyAmount: 0},
        {lineNumber: 15,  amountName:"capitalCost",      yearlyAmount: 0},
        {lineNumber: 16,  amountName:"employeeStock",    yearlyAmount: 0},
        {lineNumber: 17,  amountName:"additionsTotal",   yearlyAmount: 0},
        
    ];

    childSupportPurposeItem = [
        {lineNumber: 18,  amountName:"childSupportFund", yearlyAmount: 0}
    ];

    extraExpensesItem = [
        {lineNumber: 19,  amountName:"benefitPaid",     yearlyAmount: 0},
        {lineNumber: 20,  amountName:"spousalReceived", yearlyAmount: 0},
        {lineNumber: 21,  amountName:"spousalPaid",     yearlyAmount: 0},
        {lineNumber: 22,  amountName:"specialTotal",    yearlyAmount: 0}
    ];

    spouseExpensesItem = [
        {lineNumber: 23,  amountName:"childReceived",       yearlyAmount: 0},
        {lineNumber: 24,  amountName:"socialAssist",        yearlyAmount: 0},
        {lineNumber: 25,  amountName:"govBenefit",          yearlyAmount: 0},
        {lineNumber: 26,  amountName:"spouseSupportFund",   yearlyAmount: 0}
    ];

    incomeSummaryFields = [
        {key:"lineNumber",      label:"",    class:"line-number"}, 
        {key:"amountName",      label:"",    class:"amount-name"},
        {key:"yearlyAmount",    label:"",    class:"yearly-amount"}      
    ];

    mounted(){        
        this.reloadPageInformation();
    } 
    
    public reloadPageInformation() {        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        this.extraExpenses = false;
        this.spouseSupport = false;

        if(this.step.result?.financialStatementSurvey?.data){
            const fsData = this.step.result.financialStatementSurvey.data;            
            this.spouseSupport = fsData.spousalAppExists == 'y';
            this.extraExpenses = fsData.childAppExists == 'y' && fsData.situationType.includes("There is a claim for section 7 special or extraordinary expenses")
        }
        
        if (this.step.result?.incomeSummaryFSSurvey?.data) {
            const incomeSummaryData = this.step.result.incomeSummaryFSSurvey.data
            if (incomeSummaryData.totalIncome){
                this.totalIncomeItem = incomeSummaryData.totalIncome;
            }
            if(incomeSummaryData.deduction){
                this.deductionItem = incomeSummaryData.deduction;
            }
            if(incomeSummaryData.addition){
                this.additionItem = incomeSummaryData.addition;
            }
            if(incomeSummaryData.childSupportFund){
                this.childSupportPurposeItem = incomeSummaryData.childSupportFund;
            }
            
            if(incomeSummaryData.extraExpenses && this.extraExpenses){
                this.extraExpensesItem = incomeSummaryData.extraExpenses;
            }

            if(incomeSummaryData.spouseExpenses && this.spouseSupport){
                this.spouseExpensesItem = incomeSummaryData.spouseExpenses;
            }
            
            Vue.filter('scrollToLocation')(this.$store.state.Application.scrollToLocationName);            
        }      

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 50, false);
    }

    public inputYearlyValueChanged(){

        // calculate total deductions
        this.deductionItem[10].yearlyAmount = 0;
        const deductionsList = this.deductionItem.slice(0, this.deductionItem.length - 1)
        const totalDeductions = deductionsList.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);
        this.deductionItem[10].yearlyAmount = totalDeductions;  

        // calculate total deductions
        this.additionItem[4].yearlyAmount = 0;
        const additionsList = this.additionItem.slice(0, this.additionItem.length - 1)
        const totalAdditions = additionsList.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);
        this.additionItem[4].yearlyAmount = totalAdditions;

        //calculate total for child support
        this.childSupportPurposeItem[0].yearlyAmount = Number(this.totalIncomeItem[0].yearlyAmount) - totalDeductions + totalAdditions; 
                
        // calculate extraordinary 
        if(this.extraExpenses){
            this.extraExpensesItem[3].yearlyAmount = 0;
            const totalExtraReceived = Number(this.extraExpensesItem[0].yearlyAmount) + Number(this.extraExpensesItem[1].yearlyAmount);
            const totalExtraPaid = Number(this.extraExpensesItem[2].yearlyAmount)
            this.extraExpensesItem[3].yearlyAmount = Number(this.childSupportPurposeItem[0].yearlyAmount) + totalExtraReceived - totalExtraPaid;
        }

        // calculate spousal expenses 
        if(this.spouseSupport){
            if(this.deductionItem[5].yearlyAmount &&  this.deductionItem[10].yearlyAmount > 0){
                this.spouseExpensesItem[1].yearlyAmount = this.deductionItem[5].yearlyAmount;
            }
            this.spouseExpensesItem[3].yearlyAmount = 0;
            const spouseExpensesList = this.spouseExpensesItem.slice(0, this.spouseExpensesItem.length - 1)
            const totalSpouseExpenses = spouseExpensesList.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);
            this.spouseExpensesItem[3].yearlyAmount = Number(this.childSupportPurposeItem[0].yearlyAmount) + totalSpouseExpenses;
        }
                
        this.tableKey ++;
        this.deductionsTableKey ++;
        this.additionsTableKey ++;
        this.childSupportTableKey ++;
        this.extraExpensesTableKey ++;
        this.spouseExpensesTableKey ++;
    }        

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage()
    }

    public getIncomeResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        if(this.getIncomeInfo()){

            const incomeInfo = this.getIncomeInfo().totalIncome;
            for(const incomeType of incomeInfo) {
                questionResults.push({name:'incomeSummaryFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(Vue.filter('beautify-amount-name')(incomeType.amountName)) +' yearly amount:', inputType:''})
            }

            const deductionInfo = this.getIncomeInfo().deduction;
            for(const incomeType of deductionInfo) {
                questionResults.push({name:'incomeSummaryFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            const additionInfo = this.getIncomeInfo().addition;
            for(const incomeType of additionInfo) {
                questionResults.push({name:'incomeSummaryFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            const childSupportFundInfo = this.getIncomeInfo().childSupportFund;
            for(const incomeType of childSupportFundInfo) {
                questionResults.push({name:'incomeSummaryFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            const extraExpensesInfo = this.getIncomeInfo().extraExpenses;
            for(const incomeType of extraExpensesInfo) {
                questionResults.push({name:'incomeSummaryFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            const spouseExpensesInfo = this.getIncomeInfo().spouseExpenses;
            for(const incomeType of spouseExpensesInfo) {
                questionResults.push({name:'incomeSummaryFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }
        }  
        
        return {data: this.getIncomeInfo(), questions:questionResults, pageName:'Income Summary', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getIncomeInfo(){       

        let result = {
            totalIncome: this.totalIncomeItem,
            deduction: this.deductionItem,
            addition: this.additionItem,
            childSupportFund: this.childSupportPurposeItem,
            extraExpenses: this.extraExpensesItem,
            spouseExpenses: this.spouseExpensesItem
        }

        return result
    }
    
    beforeDestroy() {        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, true);        
        this.UpdateStepResultData({step:this.step, data: {incomeSummaryFSSurvey: this.getIncomeResults()}})
    }
}
